export enum EComponentsIds {
  FIELS_LAYOUT_BLOCK = 'fields-layout-block',
  PROCESS_LAYOUT_WRAPPER = 'process-layout-wrapper',
  PROCESS_LAYOUT_CONTANER = 'process-layout-container',
}
